import { gql } from '@apollo/client';

export const sendForgotPassword = gql`
    mutation sendForgotPassword($email: String!) {
      sendForgotPassword (email: $email) {
      status
      }
    }
    `;

export const changeForgotPassword = gql`
    mutation changeForgotPassword($email: String!, $newPassword: String!) {
     changeForgotPassword (email: $email, newPassword: $newPassword) {
       status
     }
    }
    `;

export const getHomeData = gql`{
  getHomeData {
    result {
      id
      title
      content
      getFindYouCar{
        id
        name
        value
        dynamicFindYourVehicleBlock {
          vehicleBlockId
          language
          value
        }
      }
      getBanner{
        image
      }
      dynamicBanner {
        id
        bannerId
        language
        title
        content
      }
    }
  }
  }
  `;

export const getServiceFees = gql`
    query getServiceFees{
      getServiceFees{
          id
          guestType
          guestValue
          hostType
          hostValue
          currency
          status
      }
    }
    `;

export const updateServiceFees = gql`
    mutation updateServiceFees(
      $guestType: String!, 
      $guestValue: Float!,
      $hostType: String!,
      $hostValue: Float!,
      $currency: String,
    ){
        updateServiceFees(
          guestType: $guestType,
          guestValue: $guestValue,
          hostType: $hostType,
          hostValue: $hostValue,
          currency: $currency
        ) {
            id
            guestType
            guestValue
            hostType
            hostValue
            currency
            status
        }
    }
    `;

export const adminUserLogout = gql`
    query {
        adminUserLogout {
            status
        }
      }
    `;

export const userManagement = gql`
    query userManagement($currentPage: Int, $searchList: String, $userType: String){
        userManagement(currentPage: $currentPage, searchList: $searchList, userType: $userType) {
          status
          count
          usersData{
            id,
              email,
              profile
              {
              profileId,
              firstName,
              lastName,
              gender,
              dateOfBirth,
              phoneNumber,
              preferredLanguage,
              preferredCurrency,
              location,
              info,
              createdAt
              },
              userBanStatus,
          }
         }
      }
    `;

export const updateBanServiceHistoryStatus = gql`
    mutation($id: String, $banStatus: Int) {
      updateBanServiceHistoryStatus(id: $id ,banStatus: $banStatus){
        status
        }
      }
    `;

export const getAllPaymentMethods = gql`
    query getAllPaymentMethods {
        getAllPaymentMethods {
            id
            name
            paymentName
            processedIn
            fees
            currency
            details
            isEnable
            paymentType
            createdAt
            updatedAt
            status
        }
    }
    `;

export const updatePaymentGateWayStatus = gql`
    mutation updatePaymentGateWayStatus ($id: Int!, $isEnable: Boolean!) {
        updatePaymentGatewayStatus(id: $id, isEnable: $isEnable) {
            status
        }
    }
    `;

export const updateStaticPage = gql`
    mutation updateStaticPage(
      $id: Int,
      $content: String,
      $metaTitle: String,
      $metaDescription: String,
      $dynamicStaticPage: String,
    ) {
      updateStaticPage(
        id: $id,
        content: $content,
        metaTitle: $metaTitle,
        metaDescription: $metaDescription,
        dynamicStaticPage: $dynamicStaticPage,
      ) {
          status
      }
    }
    `;

export const getEditStaticPage = gql`query getEditStaticPage ($id: Int!) {
    getEditStaticPage (id: $id) {
        id
        pageName
        content
        metaTitle
        metaDescription
        createdAt
        dynamicStaticPage {
          language
          metaTitle
          metaDescription
          content
          pageTitle
        }
      }
    }`;

export const updateWhyHost = gql`
    mutation (
      $dataList: String
    ) {
        updateWhyHost (
            dataList:$dataList
        ) {
            status
            errorMessage                     
        }
    }`;

export const AddPhoneNumber = gql`
    mutation AddPhoneNumber($countryCode: String!, $phoneNumber: String!) {
        AddPhoneNumber(countryCode: $countryCode, phoneNumber: $phoneNumber) {
            status
            countryCode
            phoneNumber
            userProfileNumber
        }
    }
    `;

export const getPhoneData = gql`query {
    getPhoneData {
        userId
        profileId
        phoneNumber
        country
        countryCode
        verification {
          id
          isPhoneVerified
        }
      }
    }`;

export const DeleteWishListGroup = gql`
    mutation DeleteWishListGroup(
        $id: Int!,
    ){
        DeleteWishListGroup(
            id: $id
        ) {
            status
        }
    }
    `;

export const getAllWishListGroupQuery = gql`query ($profileId: Int!){
    getAllWishListGroup(profileId: $profileId){
        wishListGroupData {
          id
          name
          userId
          isPublic
          updatedAt
          wishListCount
          wishListCover {
            id
            listId
            listData {
              id
              title
              personCapacity
              beds
              bookingType
              coverPhoto
              reviewsCount,
              reviewsStarRating,
              listPhotos {
                id
                name
                type
                status
              }
              listingData {
                basePrice
                currency
              }
              settingsData {
                listsettings {
                  id
                  itemName
                }
              }
            }
          }
        }
        count
        status
      }
    }`;

export const locationItem = gql`
    query ($address: String) {
      locationItem(address: $address) {
        street
        city
        state
        country
        zipcode
        lat
        lng
        status
      }
    }
    `;

export const listPhotos = gql`
    query listPhotos($listId:Int!) {
      ShowListPhotos (listId:$listId) {
        id
        listId
        name
        type
        isCover
      }
    }
    `;

export const getAllDynamicListSettings = gql`
  query getAllDynamicListSettings($locale: String) {
    getAllDynamicListSettings(locale: $locale) {
    status
    errorMessage
    results {
        id
        typeId
        listSettingsId
        language
        itemName
        otherItemName
    }
    }
  }
`;

export const getAllDynamicListTitle = gql`
query getAllDynamicListTitle($locale: String) {
	getAllDynamicListTitle(locale: $locale) {
		status
		errorMessage
		results {
			dynamicListTitle {
				id
				listId
				language
				listTitle
			}
			dynamicListDescription {
				id
				listId
				language
				listDescription
			}
      dynamicCancellationData {
				id
			  policyName
				language
			}
		}
	}
}`;

export const createReportUser = gql`
mutation(
  $reporterId: String
  $userId: String
  $reportType: String
  $profileId: Int
  $reporterName: String
  $reportId:Int,
) {
  CreateReportUser(
    reporterId: $reporterId
    userId: $userId
    reportType: $reportType
    profileId: $profileId
    reporterName: $reporterName
    reportId:$reportId
  ) {
    status
    firstName
  }
}
`;

export const sendContactEmail = `
    mutation sendContactEmail(
        $phoneNumber: String,
        $name: String,
        $email: String,
        $contactMessage: String,
        $recaptchaToken: String
      ){
          sendContactEmail(
            phoneNumber: $phoneNumber,
            name: $name,
            email: $email,
            contactMessage: $contactMessage,
            recaptchaToken: $recaptchaToken
          ) {
              status
              errorMessage
          }
    }
    `;

export const contactInquiriesQuery = gql`query getAllContactInquiriesAdmin($currentPage: Int, $searchList: String) {
      getAllContactInquiriesAdmin(currentPage: $currentPage, searchList: $searchList) {
        count
        contactInquiriesData {
          id
          name
          phoneNumber
          email
          message
        }
      }
    }`;